<template>
  <v-navigation-drawer
    :value="layout.drawer || (authReady && $vuetify.breakpoint.lgAndUp)"
    app
    :width="300"
    color="grey lighten-5"
  >
    <div class="controlpanel">
      <v-app-bar
        color="white"
        flat
      />
      <template v-if="authReady">
        <employee-controlpanel-menu v-if="authUser.is_employee"/>
        <company-controlpanel-menu v-else/>
      </template>
      <template v-else>
        <v-list>
          <template v-for="navItem in navigation">
            <v-list-group
              v-if="navItem.children"
              :key="navItem.title"
            >
              <v-list-item
                slot="activator"
                class="pl-0"
              >
                <v-list-item-title>
                  {{ $t(`content.${navItem.title}`) }}
                </v-list-item-title>
              </v-list-item>
              <template v-for="level2 in navItem.children">
                <v-divider v-if="level2.divider" :key="level2.divider" />
                <v-list-item
                  v-else
                  :key="level2.title"
                  :to="{ name: level2.routeName, hash: level2.hash }"
                  :exact="level2.exact"
                >
                  <v-list-item-action v-if="level2.icon">
                    <v-icon>{{ level2.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-title>
                    {{ $t(`content.${level2.title}`) }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list-group>
            <v-list-item
              v-else
              :key="navItem.title"
              :to="{ name: navItem.routeName }"
              :exact="navItem.exact"
            >
              <v-list-item-title>
                {{ $t(`content.${navItem.title}`) }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CompanyControlpanelMenu from '@/components/_molecules/company/ControlpanelMenu.vue';
import EmployeeControlpanelMenu from '@/components/_molecules/employee/ControlpanelMenu.vue';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');

export default {
  name: 'AppNavigation',
  components: {
    CompanyControlpanelMenu,
    EmployeeControlpanelMenu,
  },
  props: {
    layout: {
      type: Object,
    },
    authReady: {
      type: Boolean,
    },
    fetchInitialPending: {
      type: Boolean,
    },
  },
  data() {
    return {
      navigation: [
        {
          title: 'jobs.label',
          routeName: 'job.list',
          exact: false,
        },
        {
          title: 'howItWorksEmployer.label',
          children: [
            // Employee
            {
              icon: 'person',
              title: 'jobFind.label',
              subtitle: 'jobFind.forEmployees',
              routeName: 'page.find-a-job',
              hash: '',
              exact: false,
            },
            {
              title: 'howItWorksEmployee.label',
              routeName: 'page.find-a-job',
              hash: '#section-1',
              exact: true,
            },
            {
              title: 'advantagesEmployee.label',
              routeName: 'page.find-a-job',
              hash: '#section-2',
              exact: true,
            },
            {
              title: 'furtherEducation.label',
              routeName: 'page.employee.further-education',
              hash: '',
              exact: true,
            },
            {
              title: 'advantagesEmployee.unemploymentBenefits',
              routeName: 'page.employee.seco-pilot',
              hash: '',
              exact: true,
            },
            {
              title: 'employeesSays.label',
              routeName: 'page.find-a-job',
              hash: '#section-3',
              exact: true,
            },
            {
              title: 'faqsEmployees.label',
              routeName: 'page.find-a-job',
              hash: '#section-4',
              exact: true,
            },
            {
              title: 'divider',
              divider: true,
            },
            // Employer
            {
              icon: 'business',
              title: 'jobAdvertisement.findEmployees',
              subtitle: 'jobAdvertisement.forEmployers',
              routeName: 'page.job-advertisement',
              hash: '',
              exact: false,
            },
            {
              title: 'howItWorksEmployer.label',
              routeName: 'page.job-advertisement',
              hash: '#section-1',
              exact: true,
            },
            {
              title: 'advantagesEmployer.label',
              routeName: 'page.job-advertisement',
              hash: '#section-2',
              exact: true,
            },
            {
              title: 'offerEmployers.label',
              routeName: 'page.job-advertisement',
              hash: '#section-3',
              exact: true,
            },
            {
              title: 'employersSays.label',
              routeName: 'page.job-advertisement',
              hash: '#section-4',
              exact: true,
            },
            {
              title: 'faqsEmployers.label',
              routeName: 'page.job-advertisement',
              hash: '#section-5',
              exact: true,
            },
          ],
        },
        {
          title: 'careerday.label',
          routeName: 'page.careerday',
          exact: false,
        },
      ],
    };
  },
  computed: {
    ...mapUserState([
      'authUser',
    ]),
  },
  methods: {
    ...mapUserActions([
      'toggleNavigationDrawer',
    ]),
  },
};
</script>
